"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Divider = _interopRequireDefault(require("./Divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StatsBlock = function StatsBlock(props) {
  var itemLength = props.items.length;
  var items = props.items.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "statItem",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "statsContainer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "statText"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "label"
    }, element.label), /*#__PURE__*/_react["default"].createElement("p", {
      className: "mice"
    }, element.desc)), element.icon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "iconContainer"
    }, element.icon)), itemLength > 0 && index < itemLength - 1 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null));
  });
  var classes = (0, _classnames["default"])(props.className, "statsBlock-component");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: props.style
  }, items);
};

StatsBlock.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].number]),
    desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].number]),
    icon: _propTypes["default"].object
  })),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
StatsBlock.defaultProps = {
  items: [],
  className: "",
  style: {}
};
var _default = StatsBlock;
exports["default"] = _default;